export const navList = [
    {
        name: '首页', path: '/index', children: []
    },
    {
        name: '解决方案', path: '/solution', icon: require('@/assets/images/pathDown.svg'), children: []
    },
    {
        name: '产品中心', path: '/product', type: 'fileCabinet', icon: require('@/assets/images/pathDown.svg'), children: []
    },
    {
        name: '成功案例', path: '/successCase', children: []
    },
    {
        name: '关于我们', path: '/aboutUs', icon: require('@/assets/images/pathDown.svg'), children: [
            {
                name: '企业详情',
                path: '/aboutUs',
                icon: require('@/assets/images/index/head/zhzx.svg'),
                children: [
                    {name: '企业概况', path: '/aboutUs', type: 'qygk'},
                    {name: '企业文化', path: '/aboutUs', type: 'qywh'},
                    {name: '资质荣誉', path: '/aboutUs', type: 'zzry'}
                ]
            }
        ]
    },
]